import React, { useState, useEffect } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import $i18n from '@/i18n';
import Requests from '@/services/request';
import Blob from '@/services/blob';
import Uploader from '@/components/Uploader';
import { Switch, Modal, Form, Icon, Message, Upload } from '@b-design/fusion';
import Button, { FormSubmit, promisifyValidate } from '@/components/Button';
import { Field } from '@alifd/next';
import pdfImg from '@/assets/settings/pdf.svg';
import './index.less';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
const TermsAndPolicy: React.FC = () => {
  //选择预览方式 弹窗/新页面
  const [previewMode, setPreviewMode] = useState<any>('default');

  const [visible, setVisible] = useState(false);
  const [params, setParams] = useState({});

  //是否开启服务条款
  const [termsIstrue, setTermsIstrue] = useState<any>();
  //是否开启隐私权限
  const [privacyIstrue, setPrivacyIstrue] = useState<any>();

  //之前的服务条款地址
  const [preTerms, setPreTerms] = useState<any>({ publicUrl: '', relativePath: '' });
  //之前的隐私协议地址
  const [prePrivacy, setPrePrivacy] = useState<any>({ publicUrl: '', relativePath: '' });

  //预览弹窗
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isModalVisible2, setIsModalVisible2] = useState(false);
  //pdf预览url
  const [termsSite, setTermsSite] = useState('');
  const [privacySite, setPrivacySite] = useState('');
  const handleOk = () => {
    setIsModalVisible(false);
  };
  const handleClose = () => {
    setIsModalVisible(false);
  };
  const handleOk2 = () => {
    setIsModalVisible2(false);
  };
  const handleClose2 = () => {
    setIsModalVisible2(false);
  };
  //pdf预览功能
  const [numPages, setNumPages] = useState(null);

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }
  function onDocumentLoadSuccess2({ numPages }) {
    setNumPages(numPages);
  }
  const field = Field.useField();
  const { init } = field;
  //提交按钮
  const submitForm = async () => {
    const [err, value] = await promisifyValidate(field);
    if (err) {
      return;
    }
    let params = {
      ...(value?.terms?.length && { termsUrl: value?.terms[0]?.publicUrl }),
      ...(value?.privacy?.length && { policyUrl: value?.privacy[0]?.publicUrl }),
    };

    if (!termsIstrue && privacyIstrue) {
      if (value?.privacy[0]) {
        setParams({ policyUrl: value?.privacy[0]?.publicUrl });
        setVisible(true);
      } else {
        Message.error({
          title: $i18n.get({
            id: 'aopf.pages.settings.policy.pdfRemind',
            dm: '还有开启的PDF未上传',
          }),
        });
      }
    }
    if (!privacyIstrue && termsIstrue) {
      if (value?.terms[0]) {
        setParams({ termsUrl: value?.terms[0]?.publicUrl });
        setVisible(true);
      } else {
        Message.error({
          title: $i18n.get({
            id: 'aopf.pages.settings.policy.pdfRemind',
            dm: '还有开启的PDF未上传',
          }),
        });
      }
    }
    if (!termsIstrue && !privacyIstrue) {
      setParams({});
      setVisible(true);
    }
    if (termsIstrue && privacyIstrue) {
      if (value?.terms[0] && value?.privacy[0]) {
        setParams(params);
        setVisible(true);
      } else {
        Message.error({
          title: $i18n.get({
            id: 'aopf.pages.settings.policy.pdfRemind',
            dm: '还有开启的PDF未上传',
          }),
        });
      }
    }
  };
  //确认提交按钮
  const submitSettings = () => {
    Requests.post('/rest/intercnn/tenant/config?type=POLICY', { ...params }).then((data) => {
      if (data) {
        Message.success({
          title: $i18n.get({
            id: 'aopf.pages.settings.set.successfully',
            dm: '设置成功',
          }),
        });
        location.reload();
      }
    });
  };
  //服务条款二次确认弹窗
  const [isTermsVisible, setIsTermsVisible] = useState(false);

  const handleTermsOk = () => {
    setIsTermsVisible(false);
    //删除服务条款pdf
    setPreTerms({});
    setTermsIstrue(false);
  };

  const handleTermsCancel = () => {
    setIsTermsVisible(false);
  };
  const termsSwitch = (checked) => {
    if (checked) {
      setTermsIstrue(true);
    } else {
      setIsTermsVisible(true);
    }
  };
  //隐私协议二次确认弹窗

  const [isPrivacyVisible, setIsPrivacyVisible] = useState(false);

  const handlePrivacyOk = () => {
    setIsPrivacyVisible(false);
    setPrivacyIstrue(false);
    //删除隐私协议
    setPrePrivacy({});
  };

  const handlePrivacyCancel = () => {
    setIsPrivacyVisible(false);
  };
  const privacySwitch = (checked) => {
    if (checked) {
      setPrivacyIstrue(true);
    } else {
      setIsPrivacyVisible(true);
    }
  };

  //获取是否上传文件
  const getUpload = () => {
    Requests.get('/rest/intercnn/tenant/config?type=POLICY').then((res) => {
      if (res?.termsUrl) {
        setTermsIstrue(true);
        setPreTerms({ publicUrl: res?.termsUrl, relativePath: res?.termsUrl });
      }
      if (res?.policyUrl) {
        setPrivacyIstrue(true);
        setPrePrivacy({ publicUrl: res?.policyUrl, relativePath: res?.policyUrl });
      }
    });
  };
  useEffect(() => {
    getUpload();
  }, []);
  //重新上传
  const reOnSuccess = (formattedData, file) => {
    setPreTerms(formattedData.response.data);
  };
  const reOnSuccess2 = (formattedData, file) => {
    setPrePrivacy(formattedData.response.data);
  };
  const showImg = (file) => {
    if (previewMode == 'default') {
      window.open(file.fileURL);
    } else {
      setIsModalVisible(true);
      Blob.get(file.fileURL).then((res) => {
        let blob = res;
        let reader = new FileReader();
        reader.readAsDataURL(blob); // 转换为base64，可以直接放入a标签href
        reader.addEventListener('load', function () {
          let base64: any = reader.result;
          setTermsSite(base64);
        });
      });
    }
  };
  const showImg2 = (file) => {
    if (previewMode == 'default') {
      window.open(file.fileURL);
    } else {
      setIsModalVisible2(true);
      Blob.get(file.fileURL).then((res) => {
        let blob = res;
        let reader = new FileReader();
        reader.readAsDataURL(blob); // 转换为base64，可以直接放入a标签href
        reader.addEventListener('load', function () {
          let base64: any = reader.result;
          setPrivacySite(base64);
        });
      });
    }
  };
  const itemRender = (file) => {
    return (
      <div className="pdf-content">
        <img src={pdfImg} style={{ maxWidth: '100%', maxHeight: '100%' }} />
        <div className="pdf-hover">
          <div className="pdf-hover-null">
            <Icon
              onClick={() => showImg(file)}
              type="view--outline"
              size="small"
              style={{ marginRight: '22px', cursor: 'pointer' }}
            />

            <Upload
              action="/rest/intercnn/uploadPublicRead"
              onSuccess={reOnSuccess}
              accept={['.pdf']}
            >
              <Icon type="processing--outline" size="small" style={{ cursor: 'pointer' }} />
            </Upload>
          </div>
        </div>
      </div>
    );
  };
  const itemRender2 = (file) => {
    return (
      <div className="pdf-content">
        <img src={pdfImg} style={{ maxWidth: '100%', maxHeight: '100%' }} />
        <div className="pdf-hover">
          <div className="pdf-hover-null">
            <Icon
              onClick={() => showImg2(file)}
              type="view--outline"
              size="small"
              style={{ marginRight: '22px', cursor: 'pointer' }}
            />
            <Upload
              action="/rest/intercnn/uploadPublicRead"
              onSuccess={reOnSuccess2}
              accept={['.pdf']}
            >
              <Icon type="processing--outline" size="small" style={{ cursor: 'pointer' }} />
            </Upload>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="termsContent">
      <div className="title">
        {$i18n.get({
          id: 'aopf.pages.settings.termsAndPolicy.title',
          dm: '条款和协议',
        })}
      </div>
      <div className="describe">
        {$i18n.get({
          id: 'aopf.pages.settings.termsAndPolicy.des',
          dm: '条款和协议',
        })}
      </div>
      <div>
        <Form>
          <div className="termsOfService">
            {$i18n.get({
              id: 'aopf.pages.settings.termsAndPolicy.terms',
              dm: '服务条款',
            })}
          </div>
          <div className="switch-des">
            {$i18n.get({
              id: 'aopf.pages.settings.policy.switchDes',
              dm: '是否展示组件',
            })}
          </div>

          <Switch
            data-size="xs"
            defaultChecked={termsIstrue}
            checked={termsIstrue}
            data-type={'circle'}
            onChange={termsSwitch}
          />
          {termsIstrue && (
            <div className="terms-container">
              <Form.Item name="terms" className="upload">
                <Uploader.Pdf
                  {...init('terms', {})}
                  action="/rest/intercnn/uploadPublicRead"
                  accept={['.pdf']}
                  onCheckFail={(_err, response) => {
                    Message.warning({ title: response.msg });
                  }}
                  key={preTerms?.relativePath}
                  value={
                    preTerms?.relativePath
                      ? [
                          {
                            uid: '0',
                            state: 'done',
                            url: preTerms?.publicUrl,
                            downloadURL: preTerms?.publicUrl,
                            imgURL: preTerms?.publicUrl,
                            relativePath: preTerms?.relativePath,
                            publicUrl: preTerms?.publicUrl,
                            xx: pdfImg,
                          },
                        ]
                      : []
                  }
                  onError={() => {
                    Message.error({
                      title: $i18n.get({
                        id: 'aopf.pages.miniapp.drawer.form.icon.Upload.failure',
                        dm: '上传失败',
                      }),
                    });
                  }}
                  itemRender={itemRender}
                />
              </Form.Item>
            </div>
          )}

          <br />
          <div className="privacyAgreement">
            {$i18n.get({
              id: 'aopf.pages.settings.termsAndPolicy.privacy',
              dm: '隐私协议',
            })}
          </div>
          <div className="switch-des">
            {$i18n.get({
              id: 'aopf.pages.settings.policy.switchDes',
              dm: '是否展示组件',
            })}
          </div>

          <Switch
            data-size="xs"
            defaultChecked={privacyIstrue}
            checked={privacyIstrue}
            data-type={'circle'}
            onChange={privacySwitch}
          />
          {privacyIstrue && (
            <div className="terms-container">
              <Form.Item name="privacy" className="upload">
                <Uploader.Pdf
                  {...init('privacy', {})}
                  action="/rest/intercnn/uploadPublicRead"
                  accept={['.pdf']}
                  onCheckFail={(_err, response) => {
                    Message.warning({ title: response.msg });
                  }}
                  key={prePrivacy?.relativePath}
                  value={
                    prePrivacy?.relativePath
                      ? [
                          {
                            uid: '0',
                            state: 'done',
                            url: pdfImg,
                            downloadURL: prePrivacy?.publicUrl,
                            imgURL: prePrivacy?.publicUrl,
                            relativePath: prePrivacy?.relativePath,
                            publicUrl: prePrivacy?.publicUrl,
                            xx: pdfImg,
                          },
                        ]
                      : []
                  }
                  onError={() => {
                    Message.error({
                      title: $i18n.get({
                        id: 'aopf.pages.miniapp.drawer.form.icon.Upload.failure',
                        dm: '上传失败',
                      }),
                    });
                  }}
                  itemRender={itemRender2}
                />
              </Form.Item>
            </div>
          )}

          <FormSubmit
            type="primary"
            onClick={submitForm}
            validate
            style={{
              height: 40,
              fontWeight: 500,
              fontSize: 16,
              color: '#fff',
              letterSpacing: '0.15px',
              marginTop: 10,
              display: 'block',
            }}
          >
            {$i18n.get({ id: 'aopf.pages.miniapp.settleIn.Submit', dm: '提交' })}
          </FormSubmit>
        </Form>
      </div>
      <Modal
        visible={isTermsVisible}
        onOk={handleTermsOk}
        onCancel={handleTermsCancel}
        closeMode={['close', 'esc', 'mask']}
        onClose={handleTermsCancel}
        style={{ width: 400 }}
        footer={[
          <div className="dialog-footer">
            <Button className="dialog-btn" type="normal" onClick={handleTermsCancel}>
              {$i18n.get({ id: 'aopf.components.Confirm.Cancel', dm: '取消' })}
            </Button>
            <Button type="primary" onClick={handleTermsOk}>
              {$i18n.get({ id: 'aopf.components.Confirm.Ok', dm: '确定' })}
            </Button>
          </div>,
        ]}
      >
        <div className="dialog-header">
          <span className="dialog-title">
            {$i18n.get({ id: 'aopf.pages.settings.termsAndPolicy.close', dm: '关闭' })}
          </span>
        </div>
        <div className="dialog-body">
          {$i18n.get({
            id: 'aopf.pages.settings.termsAndPolicy.closeDes',
            dm: '关闭后需重新上传协议文件，是否继续？',
          })}
        </div>
      </Modal>
      <Modal
        style={{ width: 400 }}
        visible={isPrivacyVisible}
        onOk={handlePrivacyOk}
        onCancel={handlePrivacyCancel}
        closeMode={['close', 'esc', 'mask']}
        onClose={handlePrivacyCancel}
        footer={[
          <div className="dialog-footer">
            <Button className="dialog-btn" type="normal" onClick={handlePrivacyCancel}>
              {$i18n.get({ id: 'aopf.components.Confirm.Cancel', dm: '取消' })}
            </Button>
            <Button type="primary" onClick={handlePrivacyOk}>
              {$i18n.get({ id: 'aopf.components.Confirm.Ok', dm: '确定' })}
            </Button>
          </div>,
        ]}
      >
        <div className="dialog-header">
          <span className="dialog-title">
            {$i18n.get({ id: 'aopf.pages.settings.termsAndPolicy.close', dm: '关闭' })}
          </span>
        </div>
        <div className="dialog-body">
          {$i18n.get({
            id: 'aopf.pages.settings.termsAndPolicy.closeDes',
            dm: '关闭后需重新上传协议文件，是否继续？',
          })}
        </div>
      </Modal>
      <Modal
        v2
        title={$i18n.get({
          id: 'aopf.components.uploader.pdf.dialog.Title',
          dm: 'PDF预览',
        })}
        visible={isModalVisible}
        onOk={handleOk}
        footer={false}
        onClose={handleClose}
        width={1000}
        height={800}
      >
        <div>
          <Document file={termsSite} onLoadSuccess={onDocumentLoadSuccess}>
            {Array.from(new Array(numPages), (el, index) => (
              <Page
                key={`page_${index + 1}`}
                pageNumber={index + 1}
                renderAnnotationLayer={false}
                renderTextLayer={false}
                width={930}
              />
            ))}
          </Document>
        </div>
      </Modal>
      <Modal
        v2
        title={$i18n.get({
          id: 'aopf.components.uploader.pdf.dialog.Title',
          dm: 'PDF预览',
        })}
        visible={isModalVisible2}
        onOk={handleOk2}
        footer={false}
        onClose={handleClose2}
        width={1000}
        height={800}
      >
        <div>
          <Document file={privacySite} onLoadSuccess={onDocumentLoadSuccess2}>
            {Array.from(new Array(numPages), (el, index) => (
              <Page
                key={`page_${index + 1}`}
                pageNumber={index + 1}
                renderAnnotationLayer={false}
                renderTextLayer={false}
                width={930}
              />
            ))}
          </Document>
        </div>
      </Modal>

      <Modal
        title={$i18n.get({ id: 'aopf.pages.settings.submit.title', dm: '确认设置' })}
        data-size="xs"
        visible={visible}
        onOk={submitSettings}
        onCancel={() => setVisible(false)}
        closeMode={['close', 'esc', 'mask']}
        onClose={() => setVisible(false)}
        footer={[
          <div className="dialog-footer">
            <Button className="dialog-btn" type="normal" onClick={() => setVisible(false)}>
              {$i18n.get({ id: 'aopf.components.Confirm.Cancel', dm: '取消' })}
            </Button>
            <Button type="primary" onClick={submitSettings}>
              {$i18n.get({ id: 'aopf.components.Confirm.Ok', dm: '确定' })}
            </Button>
          </div>,
        ]}
      >
        {$i18n.get({ id: 'aopf.pages.settings.policy.submitDes', dm: 'PDF上传成功,刷新页面生效' })}
      </Modal>
    </div>
  );
};
export default TermsAndPolicy;
